import styled from "styled-components";

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #e5e5e5;
  padding: 43px 62px 0;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 2;
`;

Styled.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 20px;
`;

Styled.SubmitDecisionButton = styled.div`
  display: inline-block;
  height: 23px;
  width: 148px;
  line-height: 23px;
  text-align: center;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)"};
  border-radius: 5px;

  .fa-spinner,
  .fa-check {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
  }
`;

Styled.ProductTab = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: #3a3a3a;
  background: #f8f8f8;
  border: 1px solid #ddd;
  padding: 5px 10px;
  min-width: 160px;
  position: relative;
  display: flex;
  align-items: center;

  ${p =>
    p.isLink &&
    `
    color: #74abec;
  `}

  &:hover {
    cursor: pointer;
    background: #fff;
    border-bottom-color: transparent;
  }

  ${p =>
    p.isActive &&
    `
    background: #fff;
    border-bottom-color: transparent;
  `}
`;

Styled.ProductTabs = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  margin-top: 20px;
  position: relative;
  top: 1px;

  ${Styled.ProductTab} + ${Styled.ProductTab} {
    margin-left: 10px;
  }
`;

Styled.AddProductIcon = styled.div`
  font-family: Lato;
  font-size: 18px;
  color: #74abec;
  border: 1px solid #74abec;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 6px;
  right: 10px;
`;

Styled.ProductContainer = styled.div`
  border: 1px solid #ddd;
  background: #fff;
  padding: 20px;
  display: flex;
  width: 100%;
  max-width: 800px;
  align-items: flex-start;
  border-radius: 0 4px 4px 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
`;

Styled.RNDCostsContainer = styled.div`
  width: 100%;
  flex: 0 0 25%;
`;

Styled.RNDCostsRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

Styled.RNDCostsValue = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  color: #ff0000;
  padding: 5px 20px;
  flex: 0 0 50%;
`;

Styled.FeaturesContainer = styled.div`
  width: 100%;
  padding-left: 30px;
`;

Styled.ReleaseContainer = styled.div`
  width: 100%;
  flex: 0 0 20%;
`;

Styled.ProductColumnName = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  color: #383838;
  padding-left: 20px;
  line-height: 25px;
  height: 25px;

  ${p =>
    p.addVerticalAlign &&
    `
    position: relative;
    top: -2px;
  `}
`;

Styled.EmptyColumn = styled.div`
  width: 100%;
  flex: 0 0 50%;
`;

Styled.HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
`;

Styled.SensorWrapper = styled.div`
  width: 100%;
  flex: 0 0 50%;
`;

Styled.SensorImage = styled.img`
  width: 100%;
`;

Styled.Age = styled.div`
  width: 100%;
  flex: 0 0 50%;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  color: #383838;
  text-align: center;
`;

Styled.ReleaseDate = styled.div`
  width: 125px;
  height: 23px;
  border-radius: 3px;
  background: #4b4b4b;
  line-height: 23px;
  text-align: center;
  font-family: Lato;
  font-weight: normal;
  font-size: 14px;
  color: #fff;
  margin-top: 20px;
  margin-left: 20px;
`;

Styled.ProductParameterRow = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-left: 20px;
  display: flex;
  align-items: center;
`;

Styled.ProductParameterName = styled.div`
  height: 23px;
  line-height: 23px;
  font-family: Lato;
  font-weight: normal;
  font-size: 18px;
  color: #383838;
  flex: 0 0 170px;
`;

Styled.SliderWrapper = styled.div`
  width: 100%;
  height: 23px;
  position: relative;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-right: 50px;
`;

Styled.SliderInner = styled.div`
  width: 0;
  height: 21px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}

  ${p =>
    p.rank &&
    `
    width: ${p.rank * 10}%;
  `}
`;

Styled.SliderGap = styled.div`
  width: 30px;
  height: 30px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
  position: absolute;
  top: -5px;
  left: 0;
  margin-left: -15px;
  border-radius: 7px;
  font-family: Lato;
  font-weight: normal;
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 28px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}

  ${p =>
    p.rank &&
    `
    left: ${p.rank * 10}%;
  `}
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/components/pd/style.js